export const checkout = () => {
    jQuery(document).ready(function ($) {
        $(document.body).on('click', ".woocommerce-cart-form .remove", function(e){
            e.preventDefault();
            e.stopPropagation();

            var $popup = $('.confirmation-popup');
            var product_id = $(this).attr('data-product_id');
            var productTitle = $(this).parent().parent().find('.product-title-container a').text();

            $popup.find('.popup-title span').text( productTitle );
            $popup.find('.confirm-delete').attr('data-product_id', product_id);

            $('#confirmation-modal').show();

        });

        $('.confirmation-popup .exit-popup').on('click', function(e){
            e.preventDefault();

            $('#confirmation-modal').hide();
        });

        //When the user clicks anywhere outside of the modal, close it
        var modal = document.getElementById('confirmation-modal');
        window.onclick = function(event) {
            if (event.target === modal) {
                modal.style.display = "none";
            }
        }

        $('.confirm-delete').on('click', function(e){
            e.preventDefault();

            var product_id = $(this).attr('data-product_id');
            if (typeof product_id !== 'undefined') {
                $('.confirmation-popup .button-group').prepend('<div class="overlay-spinner"><div class="spinner"></div></div>');

                $.ajax({
                    type: 'POST',
                    url: woocommerce_params.ajax_url+'?action=confirm-delete',
                    data: {"action": "confirm-delete", product_id: product_id},
                    success: function (response) {


                        var parsedData = JSON.parse(response);
                        if( parsedData.removed === 'true' ) {

                            $('.custom-undo-alert').remove();
                            $('.confirmation-popup').find('.overlay-spinner').remove();

                            $('#confirmation-modal').hide();

                            $("button[name='update_cart']").prop("disabled", false).trigger("click");

                            $('.woocommerce-notices-wrapper').append(parsedData.response);

                            setTimeout(function() {
                                $('.woocommerce-notices-wrapper').empty();
                            }, 3000);

                            $(document).trigger('productRemovedFromCart', [product_id]);

                        }
                        return false;
                    }
                });
            }
        });

        $('.showlogin').on('click', function(e){
            $('.login.login_shows').toggleClass('hidden');
        });
        
        // Keeping production version
        if($('#checkoutFormCoupon')){
            var element = $("#checkoutFormCoupon");
            element.replaceWith($(`<form  class="checkout_coupon woocommerce-form-coupon" id="checkoutFormCoupon" method="post">${element.html()}</form>`));
        }
        // Keeping production version
    });
}
